// extracted by mini-css-extract-plugin
module.exports = {"container":"_2e4u7r","wrapper":"_1LYpxF","logo":"-DNxmx","message":"_36n1p2","contact":"_1NtNWL","mobile":"ck3SXN"};